"use client";

import { Box, Typography, useTheme } from "@mui/material";

function GetClipPath({
  orientation,
  ribbonF,
  ribbonR,
}: {
  orientation: "left" | "right";
  ribbonF: number;
  ribbonR: number;
}) {
  if (orientation === "right") {
    return `polygon(0 0, 100% 0, 100% calc(100% - ${ribbonF}px), 0 calc(100% - ${ribbonF}px), ${ribbonR}px calc(50% - ${ribbonF}px / 2))`;
  } else if (orientation === "left") {
    return `polygon(0 0, 0px calc(100% - ${ribbonF}px),100% calc(100% - ${ribbonF}px), calc(100% - ${ribbonR}px) calc(50% - ${ribbonF}px/2),100% 0)`;
  }
}

const FONT_SIZE_LARGE = "32px";
const FONT_SIZE_SMALL = "18px";

export default function Ribbon({
  children,
  backgroundColor,
  alwaysSmall,
  orientation,
}: {
  children: React.ReactNode;
  backgroundColor: string;
  orientation: "left" | "right";
  alwaysSmall?: boolean;
}) {
  const theme = useTheme();
  const spacingNumber = parseInt(theme.spacing(1).replace("px", ""));
  const ribbonF = spacingNumber * 2;
  const ribbonR = spacingNumber * 2;
  const ribbonHeight = spacingNumber * 10;

  const SMALL_RIBBON = {
    height: ribbonHeight / 2 + "px",
    borderLeft: `${ribbonF / 2}px solid #0000`,
    borderBottom: `${ribbonF / 2}px solid #0005`,
    paddingLeft: orientation === "right" ? 2 : 0.5,
    paddingRight: orientation === "left" ? 0.5 : 2,
    clipPath: GetClipPath({
      orientation: orientation || "left",
      ribbonF: ribbonF / 2,
      ribbonR: ribbonR / 2,
    }),
  };

  return (
    <Box
      sx={(theme) => ({
        backgroundColor: backgroundColor,
        display: "flex",
        alignItems: "center",
        color: "white",
        height: ribbonHeight + "px",
        zIndex: 50,
        borderBottom: `${ribbonF}px solid #0005`,
        borderLeft: orientation === "right" ? `${ribbonF}px solid #0000` : "",
        borderRight: orientation === "left" ? `${ribbonR}px solid #0000` : "",
        paddingLeft: 2,
        paddingRight: 2,
        clipPath: GetClipPath({
          orientation: orientation,
          ribbonF: ribbonF,
          ribbonR: ribbonR,
        }),
        [theme.breakpoints.down("sm")]: SMALL_RIBBON,
        ...(alwaysSmall ? SMALL_RIBBON : {}),
      })}
    >
      <Typography
        component="span"
        sx={(theme) => ({
          fontWeight: "500",
          display: "flex",
          alignItems: "center",
          gap: 2,
          fontSize: alwaysSmall ? FONT_SIZE_SMALL : FONT_SIZE_LARGE,
          [theme.breakpoints.down("sm")]: {
            fontSize: FONT_SIZE_SMALL,
          },
        })}
      >
        {children}
      </Typography>
    </Box>
  );
}
